import { Helmet } from "react-helmet";
import AccelerateSection from "../../components/blocks/AccelerateSection";
import useSelectedLocation from "../../helpers/useSelectedLocation";
import DigitalTransformationSection from "../home/components/DigitalTransformationSection";
import GetStartedSliderSection from "../home/components/GetStartedSliderSection";
import TestimonialsSection from "../home/components/TestimonialsSection";
import InvestingSection from "../individual/components/InvestingSection";
import LearningSection from "../start/components/LearningSection";
import FormSection from "./components/FormSection";
import HeaderSection from "./components/HeaderSection";
import SiteFooter from "../../components/layout/SiteFooter";

const Eyitayo = () => {
  const selectedLocation = useSelectedLocation();
  return (
    <div>
      <Helmet>
        <title>Utiva | Talk to Eyitayo</title>
      </Helmet>

      <HeaderSection selectedLocation={selectedLocation?.name || undefined} />

      <FormSection />

      <LearningSection />
      <TestimonialsSection />

      <DigitalTransformationSection />

      <GetStartedSliderSection selectedLocation={selectedLocation} />

      <InvestingSection />

      <AccelerateSection />

      <SiteFooter />
    </div>
  );
};

export default Eyitayo;
